import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import InputMask from 'react-input-mask';
import Select from 'react-select';

import Overlay from '../Miscelania/Overlay';
import PaymentCheckbox from './PaymentCheckbox';
import PaymentTransportEditModal from './PaymentTransportEditModal';
import getLocale from '../../i18n/getLocale';

class PaymentdTransportOpenedContent extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      payment_order_id: '',
      payments: [],
      payment_orders_list: [],
      checkbox_marked_ids: [],
      data_payment_daily: [],
      check_all_payments: false,
      props_payment_checked: false,
      checkbox_changed: 0,
      modal_props: false,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
    this.refreshTable = this.refreshTable.bind(this);
    this.modalPropsOff = this.modalPropsOff.bind(this);
    this.showModal = this.showModal.bind(this);
    this.onRowSelect = this.onRowSelect.bind(this);
    this.onSelectAll = this.onSelectAll.bind(this);

    this.locale = getLocale();
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.payment_orders_list)) {
      this.setState({payment_orders_list: newProps.payment_orders_list});
    }
    if(Array.isArray(newProps.payments)) {
      this.setState({payments: newProps.payments});
    }
  }

  showModal (value, event) {
    this.setState({ modal_props: true});
    this.modalPropsOff();
  }
  modalPropsOff (event) {
    this.setState({ modal_props: false});
  }


  refreshTable(event) {
    var header = this.refs.request_api.header('application/json');
    this.handleAlert('', '', 'open');
    var self = this;
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/pagamentos/abertos/diarias/transporte';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({payments: responseJson.data});
        }
        self.handleAlert(event.message, event.status, 'open');
        self.setState({checkbox_marked_ids: []});
        self.unmarkAllCheckbox();
        self.modalPropsOff();
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  loadDataEditModal(value, event) {
    var header = this.refs.request_api.header('application/json');
    this.handleAlert('', '', 'open');
    var id = (value);
    var self = this;
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/pagamento/editar/'+ id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data_payment_daily:responseJson.data});
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          self.showModal();
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  add(event) {
    event.preventDefault();
    if (this.state.payment_order_id === null || this.state.payment_order_id === '' ||  typeof this.state.payment_order_id === 'undefined') {
      this.handleAlert(this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeTransporte.eNecessarioSelecionarUmaOP, 'error', 'open');
    } else {
      this.handleAlert('', '', 'open');
      var datasave = {
        checkbox_marked_ids: this.state.checkbox_marked_ids,
        payment_order_id: this.state.payment_order_id,
      };
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/ordem/pagamento/incluir/pagamentos', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          if (responseJson.status === 'success') {
            self.refreshTable(responseJson);
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  delete(event) {
    event.preventDefault();
    var confirm = window.confirm(this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeTransporte.deletarPagamentosSelecionados);
    if (confirm) {
      var datasave = {
        checkbox_marked_ids: this.state.checkbox_marked_ids,
      };
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/deletar/pagamentos', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          if (responseJson.status === 'success') {
            self.refreshTable(responseJson);
          } else {
            self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: ''}});
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  ActionsButtons (cell, row) {
    var url = "";
    var botao = (
      <div className="btn-group">
        <button onClick={this.loadDataEditModal.bind(this, cell)} className='btn btn-sm btn-primary' alt={this.locale.general.editar} title={this.locale.general.editar}><i className="fa fa-fw fa-pencil"></i></button>
      </div>
    );

    return botao;
  }

  onRowSelect(row, isSelected, e) {
    let checkbox_marked_ids = this.state.checkbox_marked_ids;
    if (isSelected) {
      checkbox_marked_ids.push(row.id);
    } else {
      for (let i = 0; i < checkbox_marked_ids.length; i++) {
        if(checkbox_marked_ids[i] === row.id) {
          checkbox_marked_ids.splice(i, 1);
        }
      }
    }
    this.setState({checkbox_marked_ids: checkbox_marked_ids});
  }

  onSelectAll(isSelected, rows) {
    let checkbox_marked_ids = [];
    if (isSelected) {
      for (let i = 0; i < rows.length; i++) {
        checkbox_marked_ids.push(rows[i].id);
      }
    }
    this.setState({checkbox_marked_ids: checkbox_marked_ids});
  }

  render() {
    return (
<div>
    <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
    <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
    <h3 className="page-title ">{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeTransporte.titulo}</h3>
    <hr/>
    <form onSubmit={this.add}>
        <div className="form-group">
          <label>{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeTransporte.formulario.OrdemDePagamento}:</label>
          <Select
            className="form-field-name"
            name="payment_order_id"
            value={this.state.payment_order_id}
            searchable={true}
            placeholder={this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeTransporte.formulario.placeholder.SelecionarOrdemDePagamento}
            onChange={this.handleSelectChange.bind(this, 'payment_order_id')}
            options={this.state.payment_orders_list}
          />
        </div>
        <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-plus"></i> {this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeTransporte.formulario.botaoAdicionarAOrdemDePagamento}</button>
        <button type="button" onClick={this.delete} className="btn btn-danger btn-block"><i className="fa fa-fw fa-trash"></i> {this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeTransporte.formulario.botaoDeletarPagamentos}</button>
    </form>
    <hr/>
    <BootstrapTable data={this.state.payments} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeTransporte.tabela.semPagamentosEmAberto}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar} selectRow={ {
        mode: 'checkbox',
        clickToSelect: true,
        onSelect: this.onRowSelect,
        onSelectAll: this.onSelectAll
    } }>
      <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeTransporte.tabela.Acoes}</TableHeaderColumn>
      <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeTransporte.tabela.ID}</TableHeaderColumn>
      <TableHeaderColumn dataField="credit_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='100'>{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeTransporte.tabela.Credito}</TableHeaderColumn>
      <TableHeaderColumn dataField="staff" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='200'>{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeTransporte.tabela.Nome}</TableHeaderColumn>
      <TableHeaderColumn dataField="regime" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='150'>{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeTransporte.tabela.Regime}</TableHeaderColumn>
      <TableHeaderColumn dataField="aircraft_model" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='150'>{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeTransporte.tabela.Frota}</TableHeaderColumn>
      <TableHeaderColumn dataField="schedule_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='100'>{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeTransporte.tabela.Mes}</TableHeaderColumn>
      <TableHeaderColumn dataField="base_grade" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='200'>{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeTransporte.tabela.BaseContratual}</TableHeaderColumn>
      <TableHeaderColumn dataField="base" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='200'>{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeTransporte.tabela.BaseOperacional}</TableHeaderColumn>
      <TableHeaderColumn dataField="revision" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='100'>{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeTransporte.tabela.Revisao}</TableHeaderColumn>
      <TableHeaderColumn dataField="daily_paid" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='100'>{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeTransporte.tabela.Quantidade}</TableHeaderColumn>
      <TableHeaderColumn dataField="daily_value" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='100'>{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeTransporte.tabela.Valor}</TableHeaderColumn>
      <TableHeaderColumn dataField="daily_total" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='100'>{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeTransporte.tabela.Total}</TableHeaderColumn>
      <TableHeaderColumn dataField="daily_currency" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='100'>{this.locale.PagamentosDeEscala.PagamentosEmAbertoIndenizacaoDeTransporte.tabela.Moeda}</TableHeaderColumn>
    </BootstrapTable>
    <PaymentTransportEditModal handleAlert={this.props.handleAlert} modal_props={this.state.modal_props} data_payment_daily={this.state.data_payment_daily} refreshTable={this.refreshTable} />
</div>
    );
  }
}

export default PaymentdTransportOpenedContent;



// WEBPACK FOOTER //
// ./src/Components/SchedulePayments/PaymentTransportOpenedContent.js